// **  Initial State
const initialState = {
    stepId: "",
    routeInfo: {},
    items: [],
    relations: [],
    loading: true,
    errors: [],
    search: '',
    url: 'productRoute',
    addUrl: 'materialCreate',
    updateUrl: 'materialUpdate',
    deleteUrl: 'materialDelete',
    adding: {
        loading: false,
        isDone: false,
        errors: []
    },
    updating: {},
    publish: {},
    request: {},
    apply: {},
    certify: {},
    receive: {},
    reset_password: {},
    delete_partner: {},
    deleting: {},
    undo: {},
    categories: [],
    saveWithReloadInProgress: false,
    updatingRoute: {}, // your existing property
    updatingDevRoute: {
        loading: false,
        isDone: false,
        errors: []
    }
}


const form302Reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_FORM302_STEPS':
            return {
                ...state,
                loading: true,
                errors: []
            }

        case 'FETCH_FORM302_STEPS_SUCCESS':
            return {
                ...state,
                items: action.data.refForm302RouteSteps,
                routeInfo: action.data,
                stepId: action.data.id,
                loading: false,
                saveWithReloadInProgress: false,
                errors: []
            }

        case 'FETCH_FORM302_STEPS_FAIL':
            return {
                ...state,
                loading: false,
                saveWithReloadInProgress: false,
                errors: action.errors
            }

        case 'ADD_FORM302_STEP':
            return {
                ...state,
                adding: {
                    loading: true,
                    isDone: false,
                    errors: []
                }
            }

        case 'ADD_FORM302_STEP_SUCCESS':
            return {
                ...state,
                adding: {
                    loading: false,
                    isDone: true,
                    errors: []
                },
                items: [...state.items, action.step]
            }

        case 'ADD_FORM302_STEP_FAIL':
            return {
                ...state,
                adding: {
                    loading: false,
                    isDone: false,
                    errors: action.errors
                }
            }

        case 'DELETE_FORM302_ROUTE_STEP':
            return {
                ...state,
                deleting: {
                    ...state.deleting,
                    [action.id]: {
                        loading: true,
                        errors: []
                    }
                }
            }

        case 'DELETE_FORM302_ROUTE_STEP_SUCCESS':

            return {
                ...state,
                deleting: {
                    ...state.deleting,
                    [action.id]: {
                        loading: false,
                        errors: []
                    }
                },
                items: [...state.items.filter(o => o.id !== action.id)]
            }

        case 'DELETE_FORM302_ROUTE_STEP_FAIL':
            return {
                ...state,
                deleting: {
                    ...state.deleting,
                    [action.id]: {
                        loading: false,
                        errors: action.errors
                    }
                }
            }

        case 'PUBLISH_FORM302_ROUTE':
            return {
                ...state,
                publish: {
                    ...state.publish,
                    [action.identifier]: {
                        loading: true,
                        errors: []
                    }
                }
            }

        case 'PUBLISH_FORM302_ROUTE_SUCCESS':

            return {
                ...state,
                publish: {
                    ...state.publish,
                    [action.identifier]: {
                        loading: false,
                        errors: []
                    }
                }
            }

        case 'PUBLISH_FORM302_ROUTE_FAIL':
            return {
                ...state,
                publish: {
                    ...state.publish,
                    [action.identifier]: {
                        loading: false,
                        errors: action.errors
                    }
                }
            }

        // update cords
        case 'UPDATE_FORM302_STEP_CORDS':
            return {
                ...state,
                updating: {
                    ...state.updating,
                    [action.id]: {
                        loading: true,
                        isDone: false,
                        errors: []
                    }
                }
            }

        case 'UPDATE_FORM302_STEP_CORDS_SUCCESS':

            const cords = state.items.map(step => {
                if (step.id === action.id) return action.step; else return step
            })

            return {
                ...state,
                updating: {
                    ...state.updating,
                    [action.id]: {
                        loading: false,
                        isDone: true,
                        errors: []
                    }
                },
                cords

            }

        case 'UPDATE_FORM302_STEP_CORDS_FAIL':
            return {
                ...state,
                updating: {
                    ...state.updating,
                    [action.id]: {
                        loading: false,
                        isDone: false,
                        errors: action.errors
                    }
                }
            }

        case 'UPDATE_FORM302_PAN_ZOOM':
            return {
                ...state,
                updating: {
                    ...state.updating,
                    [action.identifier]: {
                        loading: true,
                        errors: []
                    }
                }
            }

        case 'UPDATE_FORM302_PAN_ZOOM_SUCCESS':

            return {
                ...state,
                updating: {
                    ...state.updating,
                    [action.identifier]: {
                        loading: false,
                        errors: []
                    }
                }
            }

        case 'UPDATE_FORM302_PAN_ZOOM_FAIL':
            return {
                ...state,
                updating: {
                    ...state.updating,
                    [action.identifier]: {
                        loading: false,
                        errors: action.errors
                    }
                }
            }

        case 'FETCH_CATEGORIES':
            return {
                ...state,
                loadingCategories: true
            }

        case 'FETCH_CATEGORIES_SUCCESS':
            return {
                ...state,
                categories: action.data,
                loadingCategories: false
            }

        case 'FETCH_CATEGORIES_FAIL':
            return {
                ...state,
                errorsCategories: action.errors,
                loadingCategories: false
            }

        case 'UPDATE_FORM302_ROUTE':
            return {
                ...state,
                saveWithReloadInProgress: true,
                updatingRoute: {
                    loading: true,
                    isDone: false,
                    errors: []
                }
            }

        case 'UPDATE_FORM302_ROUTE_SUCCESS':
            // Merge PATCH response into routeInfo so form UI shows updated data (f302_number, name_of_creator, md_*, etc.)
            // while keeping fields not returned by shipmentUpdate (e.g. refForm302RouteSteps)
            return {
                ...state,
                routeInfo: {
                    ...state.routeInfo,
                    ...action.data
                },
                updatingRoute: {
                    loading: false,
                    isDone: true,
                    errors: []
                }
            }

        case 'UPDATE_FORM302_ROUTE_FAIL':
            return {
                ...state,
                saveWithReloadInProgress: false,
                updatingRoute: {
                    loading: false,
                    isDone: false,
                    errors: action.errors
                }
            }

        case 'FORM302_ROUTE_OPTIMISTIC_UPDATE':
            return {
                ...state,
                routeInfo: {
                    ...state.routeInfo,
                    ...action.displayData
                }
            }

        case 'UPDATE_FORM302_DEV_ROUTE':
            return {
                ...state,
                updatingDevRoute: {
                    loading: true,
                    isDone: false,
                    errors: []
                }
            }

        case 'UPDATE_FORM302_DEV_ROUTE_SUCCESS':
            return {
                ...state,
                updatingDevRoute: {
                    loading: false,
                    isDone: true,
                    errors: []
                }
            }

        case 'UPDATE_FORM302_DEV_ROUTE_FAIL':
            return {
                ...state,
                updatingDevRoute: {
                    loading: false,
                    isDone: false,
                    errors: action.errors
                }
            }

        default:
            return state
    }
}

export default form302Reducer